module.exports = __webpack_public_path__ + "static/media/80s.e50186a1.png";